module.exports = __webpack_public_path__ + "static/media/zu.895d0062.png";